import React, { useState, useEffect, useContext, createContext } from "react";
import { getPricing } from "@/common/api/Services/Data/Pricing";
import { getCurrencies } from "@/common/api/Services/Data/Currency";
export const defaultCurrency = {
    id: "1",
    name: "United States Dollar",
    alias: "USD",
    symbol: "&#36;",
    exchangeRate: "1",
};
const CalculatorContext = createContext(undefined);
const CalculatorProvider = ({ children }) => {
    const [pricing, setPricing] = useState([]);
    const [participants, setParticipants] = useState(100);
    const [currency, setCurrency] = useState("USD");
    const [currencies, setCurrencies] = useState([defaultCurrency]);
    useEffect(() => {
        (async () => {
            const response = await getCurrencies();
            setCurrencies(response);
        })();
    }, []);
    useEffect(() => {
        (async () => {
            const response = await getPricing();
            setPricing(response);
        })();
    }, []);
    const value = {
        currency,
        setCurrency,
        pricing,
        setPricing,
        participants,
        setParticipants,
        currencies,
    };
    return (React.createElement(CalculatorContext.Provider, { value: value }, children));
};
const useCalculatorContext = () => {
    const context = useContext(CalculatorContext);
    if (context === undefined) {
        throw new Error("'useCalculatorContext' must be used within a 'CalculatorProvider'");
    }
    return context;
};
export { CalculatorProvider, useCalculatorContext };
